import {useEffect, useState} from 'react';
import {
  clearRedactionEvents,
  SignalREvent,
} from '../../../../../redux/slice/signalrSlice';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../../../redux/store';
import {REDACTION_SIGNALR_TYPE} from '../../../../../shared/constants';

export const useConcurrentWarning = () => {
  const [showWarning, setShowWarning] = useState(false);
  const [alreadyEvents, setAlreadyEvents] = useState<SignalREvent[]>([]);
  const events = useSelector(
    (state: RootState) => state.signalr.redactionEvents
  );
  const dispatch = useDispatch();
  const activeDoc = useSelector((state: RootState) => state.docView.activeDoc);
  const userId = useSelector(
    (state: RootState) => state.authenticatedUser.user.userId
  );

  useEffect(() => {
    dispatch(clearRedactionEvents());
    setShowWarning(false);
    setAlreadyEvents(events);
  }, [activeDoc, dispatch]);

  useEffect(() => {
    setAlreadyEvents(events);
  }, [dispatch]);

  useEffect(() => {
    const newAllEvents = events.filter((event) => {
      const found = alreadyEvents.find(
        (alreadyEvent) => JSON.stringify(alreadyEvent) === JSON.stringify(event)
      );
      return !found;
    });
    const newEvents = newAllEvents.filter(
      (event) =>
        event.payload?.type === REDACTION_SIGNALR_TYPE &&
        (event.payload?.payload.duplicateDocIds as number[]).includes(
          Number(activeDoc?.documentId)
        ) &&
        event?.payload?.payload?.userId !== userId
    );

    setShowWarning(newEvents.length > 0);
  }, [events, alreadyEvents, userId, activeDoc]);

  return {showWarning};
};
